import type { ChartColorV2 } from "../types";

import { getBaseColorsForThemeDefinitionOnly } from "./base-colors";
import { SEMIPUBLIC_CHART_COLORS } from "./semipublic";

const baseColors = getBaseColorsForThemeDefinitionOnly();

// Semipublic data-viz order: green → sky → forest → coral, then lighter/darker
// steps of the same hues (see `SEMIPUBLIC_CHART_COLORS`).
export const DEFAULT_ACCENT_COLORS: ChartColorV2[] = [
  ...SEMIPUBLIC_CHART_COLORS,
];

export const LIGHT_THEME_ACCENT_COLORS: ChartColorV2[] = [
  ...DEFAULT_ACCENT_COLORS,
  {
    base: baseColors.orion[10],
    tint: baseColors.orion[5],
    shade: baseColors.orion[20],
  },
];

export const DARK_THEME_ACCENT_COLORS: ChartColorV2[] = [
  ...DEFAULT_ACCENT_COLORS,
  {
    base: baseColors.orion[80],
    tint: baseColors.orion[80],
    shade: baseColors.orion[110],
  },
];
